var NmcsState = class {
	finalUpdate(_action) {}
};
export { NmcsState };

//# sourceMappingURL=index130.js.map